// extracted by mini-css-extract-plugin
export default {"componentWrapper":"MessageSettings_componentWrapper__QggJl","notifications":"MessageSettings_notifications__-q3fL","notification":"MessageSettings_notification__yH1Yf"};